export function ModoContainer ({ children, titulo }) {
  return (
    <div className='flex flex-col h-full w-fit p-5'>
      <div className='flex flex-col gap-2'>
        <h4 className='text-2xl font-bold'>{titulo}</h4>
          <div className='grid gap-2.5 max-sm:grid-cols-1 2xl:grid-cols-4 xl:grid-cols-3 lg:grid-cols-2'>
            {children}
          </div>
      </div>
    </div>
  )
}
